import { render, staticRenderFns } from "./InboundDeliveryCreate.vue?vue&type=template&id=85207a5a&scoped=true&"
import script from "./InboundDeliveryCreate.vue?vue&type=script&lang=js&"
export * from "./InboundDeliveryCreate.vue?vue&type=script&lang=js&"
import style0 from "./InboundDeliveryCreate.vue?vue&type=style&index=0&id=85207a5a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85207a5a",
  null
  
)

export default component.exports